import React, { useEffect, useState } from "react";
import ReactToPrint from "react-to-print";
import "./styling.css";
import axios from "axios";
import { TextField } from "@mui/material";
import companylogo from "../../assets/company.png"

const SalesmanReport = ({ id }) => {
    const componentRef = React.createRef();
    const [entityData, setEntityData] = useState([]);
    const [endDate, setEndDate] = useState();
    const [startDate, setStartDate] = useState();

    useEffect(() => {
        const fetchReportData = async () => {
            try {
                if (id) {
                    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/salesmanreports/get_client_reports?id=${id}`);
                    setEntityData(response.data.salesmanreports);
                } else {
                    console.error("No ID found in id:", id);
                }
            } catch (error) {
                console.log(error.message);
            }
        };

        fetchReportData();
    }, [id]);

    const formatDate = (dateString) => {
        const dateObject = new Date(dateString);
        const day = ('0' + dateObject.getDate()).slice(-2);
        const month = dateObject.toLocaleString('default', { month: 'short' });
        const year = dateObject.getFullYear().toString().slice(-2);
        return `${day}-${month}-${year}`;
    };

    const filteredData = entityData.filter((data) => {
        if (startDate && endDate) {
            const startDateObj = new Date(startDate);
            const endDateObj = new Date(endDate);
            const currentDate = new Date(data.date);
            return currentDate >= startDateObj && currentDate <= endDateObj;
        }
        return true;
    });

    const NetInvtotal = filteredData && filteredData.reduce((total, data) => total + parseFloat(data.inv_total), 0);

    return (
        <>
            <div className="w-full">
                <div className='mb-5 flex flex-row justify-center items-center gap-2'>
                    <TextField
                        type='date'
                        value={startDate || ''}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                    <TextField
                        type='date'
                        value={endDate || ''}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </div>
                <main
                    className="m-5 p-5 xl:grid grid-cols-1 gap-10 xl:items-start"
                    style={{
                        maxWidth: "1920px",
                        margin: "auto",
                    }}
                >
                    <div className="invoice__preview bg-white p-5 rounded-2xl border-4 border-blue-200  ">
                        <ReactToPrint
                            trigger={() => (
                                <button className="bg-blue-500 ml-5 text-white font-bold py-2 px-8 rounded hover:bg-blue-600 hover:text-white transition-all duration-150 hover:ring-4 hover:ring-blue-400">
                                    Print / Download
                                </button>
                            )}
                            content={() => componentRef.current}
                        />
                        <div ref={componentRef} className="py-5 px-8 flex flex-col min-h-full print:w-[210mm] print:h-[100mm] relative">
                            <div className="">
                                <div className="flex flex-col items-center justify-center mb-5 xl:flex-row xl:justify-center w-full">
                                    <div>

                                        <img  src={companylogo} alt="logo" />
                                    </div>
                                </div>
                                <div className="w-full rounded-lg mt-2 mb-7 border-black border-[2px] flex flex-col justify-center items-center">
                                    <h1 className="text-[20px] font-bold uppercase">Salesman Report</h1>
                                </div>
                                <table width="100%" className="mb-10 ">
                                    <thead>
                                        <tr className=" text-center bg-gray-100 p-1 py-2 text-base text-black border-t border-b border-black uppercase w-full font-semibold">
                                            <td className="font-bold">DOCID #</td>
                                            <td className="font-bold">DATE</td>
                                            <td className="font-bold">Salesman Id</td>
                                            <td className="font-bold">Salesman Name</td>
                                            <td className="font-bold text-center">Inv. Total</td>
                                        </tr>
                                    </thead>
                                    {filteredData.length > 0 ? (
                                        <tbody>
                                            {filteredData.map(({ docid, date, salesmanid, salesman, inv_total }, index) => {
                                                const formattedDate = formatDate(date);
                                                return (
                                                    <tr key={index} className="h-10 w-full">
                                                        <td>{docid}</td>
                                                        <td>{formattedDate}</td>
                                                        <td className="text-center">{salesmanid}</td>
                                                        <td>{salesman}</td>
                                                        <td className="text-end">{inv_total}</td>
                                                    </tr>
                                                );
                                            })}
                                            <tr className=" text-center  h-14 font-bold mt-2 ">
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td>Inv Net Total:</td>
                                                <td className="underline text-end">{NetInvtotal.toLocaleString()}</td>
                                            </tr>
                                            <tr className=" text-center h-10 font-bold mt-2 ">
                                                <td className=" font-bold text-lg border-t border-black text-center" colSpan={2}>Accountant</td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td ></td>
                                            </tr>
                                        </tbody>
                                    ) : (
                                        <tbody>
                                            <tr>
                                                <td colSpan="5" className="text-center">No data available</td>
                                            </tr>
                                        </tbody>
                                    )}
                                </table>
                            </div>
                        </div>
                    </div>
                </main>
            </div>
        </>
    );
};

export default SalesmanReport;